var _defs, _polygon, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Background",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbec0;opacity:.1;}.cls-2{fill:#fff;}.cls-3{fill:#449bc9;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.96 90 111.96 30 60 0 8.04 30 8.04 90 60 120 111.96 90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m88.24,39.4l-.31-.31h0l-14.06-14.06s0,0,0,0l-.26-.26c-.83-.83-1.95-1.29-3.13-1.29h-35.18c-2.65,0-4.81,2.16-4.81,4.81v63.44c0,2.65,2.16,4.81,4.81,4.81h49.43c2.65,0,4.81-2.16,4.81-4.81v-49.2c0-1.18-.46-2.29-1.29-3.13Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.36,
    y: 39.65,
    width: 9.97,
    height: 9.78
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m84.72,96.54h-49.43c-2.65,0-4.81-2.16-4.81-4.81V28.28c0-2.65,2.16-4.81,4.81-4.81h35.18c1.18,0,2.29.46,3.13,1.29l14.64,14.64c.83.83,1.29,1.95,1.29,3.13v49.2c0,2.65-2.16,4.81-4.81,4.81ZM35.28,26.47c-.99,0-1.8.81-1.8,1.8v63.44c0,.99.81,1.8,1.8,1.8h49.43c.99,0,1.8-.81,1.8-1.8v-49.2c0-.38-.15-.73-.41-1l-14.64-14.64c-.27-.27-.62-.41-1-.41h-35.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m86.81,42.82h-9.3c-3.77,0-7.34-3.44-7.34-7.08v-9.3c0-.8.5-1.51,1.29-1.84.84-.35,1.8-.18,2.4.41l14.06,14.06c.66.66.9,1.78.55,2.62-.29.69-.92,1.12-1.66,1.12Zm-1.02-1.61s0,0,0,0h0Zm-12.61-12.61v7.14c0,2.01,2.19,4.07,4.33,4.07h6.88l-11.21-11.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m68.17,61.65h-26.86c-.83,0-1.51-.67-1.51-1.51s.67-1.51,1.51-1.51h26.86c.83,0,1.51.67,1.51,1.51s-.67,1.51-1.51,1.51Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m78.68,73.32h-37.37c-.83,0-1.51-.67-1.51-1.51s.67-1.51,1.51-1.51h37.37c.83,0,1.51.67,1.51,1.51s-.67,1.51-1.51,1.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m78.68,85h-37.37c-.83,0-1.51-.67-1.51-1.51s.67-1.51,1.51-1.51h37.37c.83,0,1.51.67,1.51,1.51s-.67,1.51-1.51,1.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m55.33,50.94h-14.01c-.83,0-1.51-.67-1.51-1.51v-14.01c0-.83.67-1.51,1.51-1.51h14.01c.83,0,1.51.67,1.51,1.51v14.01c0,.83-.67,1.51-1.51,1.51Zm-12.51-3.01h11v-11h-11v11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentos);
export default __webpack_public_path__ + "static/media/documentos.355249403f10691df7d17a3a1c07df17.svg";
export { ForwardRef as ReactComponent };